import { withAPIAccount } from '../../lib/http/api';
import { APIError, parsedResponse } from '../../lib/http/http';
import { AccountType } from '../../model';
import { INews, IQueryNews } from '../../model/api-modules';
import { API_PREFIX } from '../config';

// 获取消息列表
export const getNewsList = (data: IQueryNews) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${API_PREFIX}/news`;
      const response = await api.commonRequest('GET', url, data);
      const res = await parsedResponse<{ list: INews[] }>(response, 'data');
      return res;
    } catch (err: any) {
      if (err instanceof APIError) {
        console.log('error', err?.apiError?.message);
      }
      return null;
    }
  });
